module.exports = __webpack_public_path__ + "img/ccl_detail.ba13afe9.jpg";